import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const authApi = (token) => axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
});

export const money = (v, currency = "EUR") =>
  new Intl.NumberFormat("en-EU", { style: "currency", currency }).format(v || 0);

export const BRAND = {
  logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_ed09b987-e05c-4272-887c-b8620858cd8f/artifacts/idibsbtj_mrcH05_Branca.webp",
  matAvatar: "https://static.prod-images.emergentagent.com/jobs/ed09b987-e05c-4272-887c-b8620858cd8f/images/76d702ec542624dbd6f84b33d4e49da31b3a34c4b8d277f8fb2de56dded25120.jpeg",
  matAvatarLg: "https://static.prod-images.emergentagent.com/jobs/ed09b987-e05c-4272-887c-b8620858cd8f/images/76d702ec542624dbd6f84b33d4e49da31b3a34c4b8d277f8fb2de56dded25120.jpeg",
  hero: "https://customer-assets-lxgj4vgw.emergentagent.net/job_ed09b987-e05c-4272-887c-b8620858cd8f/artifacts/mzologbv_PRESHHGO%201.png",
  case: "https://customer-assets-lxgj4vgw.emergentagent.net/job_ed09b987-e05c-4272-887c-b8620858cd8f/artifacts/iiedzxx2_post02.png",
  open: "https://customer-assets-lxgj4vgw.emergentagent.net/job_ed09b987-e05c-4272-887c-b8620858cd8f/artifacts/v1aipub3_post03.png",
  bottle: "https://customer-assets-lxgj4vgw.emergentagent.net/job_ed09b987-e05c-4272-887c-b8620858cd8f/artifacts/n2nynh9o_21032026-IMG_5813.webp",
  kevin: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/nw123vok_KEVIN%20HIGH.jpg",
  bartenderCocktail: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/dqn4cawr_21032026-IMG_5930.webp",
  bartenderYellow: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/24z6bck4_21032026-IMG_5811.webp",
  bartenderSplash: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/lcwi3rv8_21032026-IMG_6166.webp",
  manualUrl: "/manuals/preshh-go-user-manual.pdf",
  recipesUrl: "/manuals/preshh-recipes.pdf",
  // Preshh Arts editorial gallery — each entry has caption + alt for SEO (Open Graph, JSON-LD, alt attributes).
  arts: [
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/7zbopmlh_19052026-IMG_0467.webp",
      caption: "The kit — sealed, ready, and quietly powerful.",
      alt: "Bartender holding the Preshh portable carbonation case against a blue-lit backdrop" },
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/dqn4cawr_21032026-IMG_5930.webp",
      caption: "Behind the bar at Marlindo 1959 — where the Preshh ritual becomes hospitality.",
      alt: "Bartenders behind a colourful bar preparing carbonated drinks with the Preshh system" },
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/24z6bck4_21032026-IMG_5811.webp",
      caption: "Craft in motion — the tools of a modern bartender.",
      alt: "Close-up of a bartender's hands preparing a cocktail with Preshh carbonation gear" },
    { url: "https://customer-assets-lxgj4vgw.emergentagent.net/job_ed09b987-e05c-4272-887c-b8620858cd8f/artifacts/n2nynh9o_21032026-IMG_5813.webp",
      caption: "Split-second serves — the moment carbonation reaches the stage.",
      alt: "Bartender pouring a freshly carbonated drink from a Preshh bottle into a glass" },
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/g3rctlz9_19052026-IMG_0387.webp",
      caption: "Ingredients first — the discipline behind every sparkling serve.",
      alt: "Preparation of ingredients ahead of a Preshh carbonation cycle" },
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/jmb44c94_16052026-IMG_0243.webp",
      caption: "Signature serves — original drinks built around fine, lively carbonation.",
      alt: "Signature Preshh cocktail served in a clean modern glass" },
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/p2vyeupv_16052026-IMG_0160.webp",
      caption: "Sparkling cocktails — vibrant bubbles that add texture to every pour.",
      alt: "A sparkling cocktail freshly poured with lively bubbles" },
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/qjhyq5ge_21032026-IMG_5962.webp",
      caption: "The pour — amber sparkle over crystal-clear ice.",
      alt: "Amber sparkling cocktail poured from a Preshh bottle over cracked ice" },
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/m5m6j1ae_20052026-IMG_0663.webp",
      caption: "A perfect Carbonation — texture, not just fizz.",
      alt: "Preshh-carbonated drink with a dense, creamy foam head" },
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/r0h64x79_19052026-IMG_0392.webp",
      caption: "The moment of pressure — where every recipe comes alive.",
      alt: "Bartender using the Preshh carbonation system on a vivid orange preparation" },
    { url: "https://customer-assets-eiarnc6j.emergentagent.net/job_beverage-tech-1/artifacts/2p5kfoyt_20052026-IMG_3984.webp",
      caption: "The finished bottle — bright, alive, ready for the glass.",
      alt: "Bartender smiling while holding a completed Preshh bottle of yellow sparkling liquid" },
  ],
};
